/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalDocumentFileInfoDto } from '../transmittalDocumentFileInfoDto.schema';

export const IReadOnlyListOfTransmittalDocumentFileInfoDto = zod.array(zod.lazy(() => TransmittalDocumentFileInfoDto));

export type IReadOnlyListOfTransmittalDocumentFileInfoDto = zod.input<typeof IReadOnlyListOfTransmittalDocumentFileInfoDto>;
export type IReadOnlyListOfTransmittalDocumentFileInfoDtoOutput = zod.output<typeof IReadOnlyListOfTransmittalDocumentFileInfoDto>;
